export default {
  headers: {
    guest: 'Huésped',
    without_room: 'Sin habitación',
    guest_checkin: 'Check-in del huésped',
    data_registry: 'Registro de datos',
    data_validation: 'Validación de datos',
    accept_terms_and_conditions: 'Acepta los términos y condiciones',
    guest_checkin_completed: 'Datos del huésped',
    personal_data: 'Datos personales',
    contact_data: 'Datos de contacto',
    terms_of_service: 'Términos de servicio',
    room: 'Habitación',
    password: 'Crea tu contraseña para la próxima vez',
    emails_linked: 'Correos electrónicos vinculados a esta reserva',
  },
  success: {
    settings: 'Se ha guardado la nueva configuración',
    change_password: 'Se ha guardado la nueva contraseña',
    contact_data: 'Se ha guardado los datos de contacto',
    checkin: 'Se ha guardado los datos de la reserva',
    payment_completed: 'Pago completado',
  },
  error: {
    no_data: 'Sin dato',
    not_found: '¡Oops! Parece que lo que estás buscando ya no existe',
    guest_id: 'No se ha econtrado el huésped',
    change_password: 'La contraseña actual no es correcta',
    server_disconnected: 'No hay conexión con el servidor',
    too_many_requests_exception: '¡Ups! El sistema ha recibido demasiadas peticiones, por favor inténtalo de nuevo en {time}s',
    server_error: 'Error en el servidor',
    forbidden: 'Acción no permitida',
    not_enough_balance: 'No hay suficiente saldo en la cuenta',
    disabled_account: 'La cuenta se ha deshabilitado',
    disabled_guest: 'El huésped a nombre de quien se ha intentado reservar se encuentra deshabilitado',
    limit_exceded: 'Esta reserva sobrepasará el límite de consumo establecido para la cuenta de pago',
    payment_error: 'Ha habido un error durante el proceso de pago',
    requested_date: {
      not_available: {
        ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
        IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
      },
    },
    available_slots: {
      hour_is_passed: {
        ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
        IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
      },
      final_hour_is_passed: {
        ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
        IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
      },
      not_in_range: {
        ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
        IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
      },
      generic: 'Ha ocurrido un error. Revisa los datos proporcionados o contacta con el personal si el problema persiste',
    },
    cannot_reserve_from: {
      ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
      IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
    },
    minimum_moment_for_reserve: {
      ROOM_SERVICE: 'Parece que has tardado demasiado en completar tu pedido. Selecciona una nueva hora de entrega',
      IN_VENUE: 'Parece que has tardado demasiado en completar tu reserva. Selecciona una nueva hora',
    },
    maximum_capacity_exceeded: {
      ROOM_SERVICE: 'Se han solicitado más pedidos mientras completabas el pedido y ya no hay disponibilidad para la hora seleccionada. Por favor, selecciona una hora diferente.',
      IN_VENUE: 'Se han realizado más reservas mientras completabas el proceso y ya no hay disponibilidad para la hora seleccionada. Por favor, selecciona una hora diferente.',
    },
    title: {
      failed_payment: 'El pago ha fallado',
      processing_payment: 'Estamos procesando el pago',
    },
    text: {
      failed_payment: 'La reserva será aceptada una vez completado el pago',
      processing_payment: 'Recibirás un correo electrónico de confirmación cuando se procese. Puedes ver el estado actualizado de la reserva en la sección <span class="font-weight-bold">{dashboardName}</span>.',
    },
  },
  document_scan_tips: {
    tip_1: 'Asegúrate de que el documento es legible y está centrado',
    tip_2: 'Las esquinas del documento deben ser visibles',
    tip_3: 'Evita los reflejos de luz en la medida de lo posible',
  },
  actions: {
    loading: 'Cargando...',
    sign_in: 'Iniciar sesión',
    sign_out: 'Cerrar sesión',
    edit_settings: 'Editar configuración',
    change_password: 'Cambiar contraseña',
    save: 'Guardar',
    cancel: 'Cancelar',
    select: 'Seleccionar',
    dismiss: 'Descartar',
    front_side_photo: 'Foto del frente',
    back_side_photo: 'Foto del reverso',
    next: 'Siguiente',
    back: 'Anterior',
    checkin_start: 'Empezar proceso',
    checkin_in_progress: 'Continuar proceso',
    checkin_completed: 'Completado',
    download_signed_document: 'Descargar documento firmado',
    open_terms_of_service: 'Ver términos de servicio',
    close: 'Cerrar',
    accept: 'Aceptar',
    clear_signature: 'Borrar firma',
    set_password: 'Crear contraseña',
    ignore_for_now: 'Ignorar por ahora',
    upload_photo: 'Tomar foto',
    continue: 'Continuar',
    confirm: 'Confirmar',
    go_back: 'Regresar',
    make_payment: 'Realizar pago',
    refresh: 'Refrescar',
  },
  time_format: {
    AM_PM: 'AM/PM',
    H_24: '24h',
  },
  first_day_of_week: {
    MONDAY: 'LUNES',
    FRIDAY: 'VIERNES',
    SATURDAY: 'SÁBADO',
    SUNDAY: 'DOMINGO',
  },
  gender: {
    male: 'Masculino',
    female: 'Femenino',
    other: 'Otro',
  },
  document_type: {
    ID_CARD: 'Documento de identidad',
    PASSPORT: 'Pasaporte',
  },
  measurement_unit: {
    ms: 'ms',
    s: 's',
    min: 'min',
    h: 'h',
    day: 'd',
    year: 'a',
    minute_quantified: '0 minutos | 1 minuto | {count} minutos',
    hour_quantified: '0 horas | 1 hora | {count} horas',
    day_quantified: '0 días | 1 día | {count} días',
    year_quantified: '0 años | 1 año | {count} años',
  },
  fields: {
    name: 'Nombre',
    surname: 'Apellidos',
    phone: 'Teléfono',
    birthdate: 'Fecha de nacimiento',
    email: 'Correo electrónico',
    password: 'Contraseña',
    sign_in_email: 'Correo electrónico',
    language: 'Idioma',
    old_password: 'Contraseña actual',
    new_password: 'Nueva contraseña',
    repeat_new_password: 'Repetir nueva contraseña',
    payment_account: 'Cuenta de pago',
    checkin: 'Fecha de entrada',
    checkout: 'Fecha de salida',
    nationality: 'Nacionalidad',
    document_type: 'Tipo de documento',
    gender: 'Género',
    address: 'Dirección',
    document_expiration: 'Fecha de caducidad',
    checkin_step2_confirm: 'Confirmo que todos los datos están completos y son correctos',
    country: 'País',
    place_of_birth: 'Lugar de nacimiento',
    document: 'Documento',
    date: 'Fecha',
    time: 'Hora',
    adults: 'Adultos',
    children: 'Niños',
    guest: 'Huésped',
    in_whose_name: 'A nombre de',
    signature: 'Firma',
    sign_here: 'Firma aquí',
    room: 'Habitación',
    comments: 'Comentarios',
    requested_date: 'Fecha solicitada',
    attendees: 'Asistentes',
    reason: 'Motivo',
    display_currency: 'Divisa de visualización de precios',
    you: 'Tú',
    time_format: 'Formato de hora',
    first_day_of_week: 'Primer día de la semana',
  },
  main: {
    loading_bookings: 'Cargando reserva, un momento...',
    no_bookings: 'No hay ninguna reserva activa',
    cookies_policy: 'Política de cookies',
    privacy_policy: 'Política de privacidad',
  },
  cookies: {
    cookies_not_shown_in_localhost: 'Declaración de cookies no disponible en entorno de desarrollo.',
    cookie_modal_id_not_specified: 'ID de modal de cookies no especificada en configuración.',
  },
  account_options: {
    booking: 'Reserva',
    room: 'Habitación',
    guest: 'Huésped',
  },
  accounts: {
    postpaid_currency: 'Moneda pospago',
    no_selected_currencies: 'No hay divisas seleccionadas',
    select_currencies: 'Selecciona una o más monedas para filtrar las transacciones',
    balance_by_currencies: 'Balance por divisas',
    remove_all_filters: 'Quitar todos los filtros',
    show_more: 'Ver más',
    show_less: 'Ver menos',
    show_all: 'Ver todo',
    close: 'Cerrar',
    apply_filters: 'Aplicar filtros',
    balance: 'Balance',
    deactivated_account: 'Cuenta desactivada',
    no_more_transactions: 'No hay más transacciones',
    no_transactions: 'No hay transacciones',
  },
  checkin: {
    no_name: 'Sin nombre',
    exempt: 'Registro no necesario',
    image_crop: {
      crop_tip: 'Ajusta el recuadro al documento',
      confirm: '¿Es visible la información del documento?',
      instructions: 'Encaja el recuadro alrededor del documento de forma que las cuatro esquinas encajen con las del recuadro. Rota la imagen de ser necesario.',
      actions: {
        crop_image: 'Recortar imagen',
        rotate: 'Rotar',
        edit_again: 'Volver a editar',
      },
    },
  },
  validations: {
    messages: {
      required: 'Obligatorio',
      min: 'Este campo debe tener al menos {length} caracteres',
      max: 'Este campo debe tener como máximo {length} caracteres',
      email: 'Este campo debe tener formato de correo electrónico',
      confirmed: 'Los campos de contraseña no coinciden',
    },
  },
  login: {
    access_mail_sent: 'Si el correo pertenece a un usuario registrado, recibirás un enlace de acceso en breves momentos.',
    error: 'Parece que ha habido un error y no hemos podido enviar tus credenciales. Inténtalo más tarde.',
    log_in_with_password: 'Ingresar mi contraseña',
    enter_to_password: 'Ingresa tu contraseña',
    send_access_link: 'Envíame un enlace mágico',
    info_access_link: 'Esta opción te dará acceso inmediato a tu cuenta sin contraseña',
    success_access_link: 'El enlace mágico ha sido enviado al correo electrónico facilitado.',
    check_your_email: 'Consulta tu correo electrónico',
    authentication: 'Autenticación',
    access_route: 'Para obtener acceso a este contenido, inicia sesión.',
    welcome: '¡Bienvenido al portal web para invitados!',
    instructions: 'Por favor ingresa tus datos para obtener acceso a tu cuenta',
    dont_send_email: '¿No has recibido el correo electrónico? Por favor revisa tu carpeta de correo no deseado o',
    try_diferent_email: 'prueba con otro correo electrónico',
    or: 'o',
    no_account: '¿No tienes cuenta?',
    create_one: '¡Crea una!',
  },
  texts: {
    waiting_validation: 'Esperando validación de datos',
    be_patient: 'Por favor, ten paciencia. Este proceso puede llevar algo de tiempo.',
    document_scan_failed: {
      INVALID_RESPONSE: 'El servicio de validación no está disponible en estos momentos. Por favor, reinténtalo más tarde.',
      INVALID_RESPONSE_BODY: 'Validación fallida. Sube nuevas fotos y asegúrate de que tu documento sea legible y esté correctamente alineado.',
      INVALID_CHECK_NUMBERS: 'Validación fallida. Sube nuevas fotos y asegúrate de que tu documento sea legible y esté correctamente alineado.',
      MISSING_REQUIRED_DATA: 'Validación fallida. Sube nuevas fotos y asegúrate de que tu documento sea legible y esté correctamente alineado.',
    },
    document_expired: 'Tu documento ha caducado. No puedes continuar el proceso con un documento caducado. Por favor sube un documento diferente.',
    without_account: 'No hay cuentas asociadas a esta reserva',
  },
  activity_reservation: {
    name: 'Reserva',
    reservation: 'reserva',
    order: 'pedido',
    title: 'Confirma tu {entityType}',
    summary_warning: 'Revisa los datos y confirma para completar tu reserva',
    registered_reservation: 'La reserva se ha realizado y ahora esta disponible en la sección <span class="font-weight-bold">{dashboardName}</span>.',
    slot_notification_min: {
      ROOM_SERVICE: 'Puedes hacer un pedido hasta {time} antes de la hora de entrega deseada.',
      IN_VENUE: 'Puedes hacer una reserva hasta {time} antes de la hora deseada.',
    },
    slot_notification_max: {
      ROOM_SERVICE: 'Puedes hacer un pedido cuando falten menos de {time} para la hora deseada.',
      IN_VENUE: 'Puedes hacer una reserva cuando falten menos de {time} para la hora deseada.',
    },
    leeway_time_before_activity_service_start: {
      ROOM_SERVICE: 'Puedes hacer un pedido hasta {time} antes de que dé comienzo el servicio.',
      IN_VENUE: 'Puedes hacer una reserva hasta {time} antes de que dé comienzo el servicio.',
    },
    leeway_time_before_activity_service_start_init: {
      ROOM_SERVICE: 'No puedes hacer un pedido una vez hayan empezado las horas de servicio.',
      IN_VENUE: 'No puedes hacer una reserva una vez hayan empezado las horas de servicio.',
    },
    fully_booked: 'Aforo completo',
    actions: {
      back: {
        IN_VENUE: 'Volver a la reserva',
        ROOM_SERVICE: 'Volver al pedido',
      },
      confirm: 'Confirmar',
      confirm_and_pay: 'Confirmar y pagar',
      check: 'Ver {entityType}',
      browse_other_activities: 'Descubrir otras actividades',
      manage: 'Gestionar',
      go_to_updated: {
        IN_VENUE: 'Ir a reserva actualizada',
        ROOM_SERVICE: 'Ir a pedido actualizado',
      },
      see_all: 'Ver todo',
      see_past_reservations: 'Ver reservas anteriores',
    },
    error: {
      error: 'Error',
      generic_error_1: '¡Oops! Parece que ha ocurrido un error',
      generic_error_2: 'Si el problema persiste, acude a recepción para que podamos ayudarte.',
      back: 'Volver',
      retry: 'Reintentar',
      history_error: 'No puede obtenerse el historial en este momento',
      required_field: 'Campo requerido',
      webapp_payment_method: {
        refund: 'Acude a recepción, se requiere la validación del reembolso por parte del procesador de pagos.',
      },
    },
    warning: {
      some_product_included: 'Uno o más productos de tu pedido están incluidos en la estancia.',
      minimum_order_units: ' | Añade {qtyProducts} producto más a tu carrito y completa tu pedido. | Añade {qtyProducts} productos más a tu carrito y completa tu pedido.',
      no_checkin_or_checkout: 'Alguna estancia relacionada no tiene fecha de entrada o salida',
      reservation_method_first_date: 'Disponible a partir del {date} a las {hour}.',
      reservation_method_no_room: 'No disponible sin habitaciones en la reserva.',
      no_booking: 'Reserva de hotel necesaria',
      select_payment_method: 'Selecciona un método de pago',
      no_payment_methods: 'No hay métodos de pago disponibles',
    },
    edit: {
      title: 'Gestionar reserva',
      pending_modification: 'Tu reserva está actualmente a la espera de confirmación por parte de la admistración.',
      must_be_approved: 'Puedes solicitar un cambio de tu reserva. Los cambios se aplicarán una vez aprobados por la administración.',
      unavailable_edition: {
        IN_VENUE: 'Cambio disponible hasta {time} antes de la hora de la reserva',
        ROOM_SERVICE: 'Cambio disponible hasta {time} antes de la hora del pedido',
      },
      unavailable_cancellation: {
        IN_VENUE: 'Cancelación disponible hasta {time} antes de la hora de la reserva',
        ROOM_SERVICE: 'Cancelación disponible hasta {time} antes de la hora del pedido',
      },
      manage_past_limit: {
        IN_VENUE: 'Para cancelar o modificar una reserva pasada, acude a recepción',
        ROOM_SERVICE: 'Para cancelar o modificar un pedido pasado, acude a recepción',
      },
      permission: 'Entiendo que en caso de que la petición sea rechazada, mi reserva será cancelada, y que esta solicitud de cambio no es reversible.',
      request_modification: 'Solicitar cambio',
      modify: {
        IN_VENUE: 'Modificar reserva',
        ROOM_SERVICE: 'Modificar pedido',
      },
      cancel: {
        IN_VENUE: 'Cancelar reserva',
        ROOM_SERVICE: 'Cancelar pedido',
      },
      cancellation_success: {
        IN_VENUE: 'Reserva cancelada correctamente',
        ROOM_SERVICE: 'Pedido cancelado correctamente',
      },
      cancellation_error: 'Error al solicitar la cancelación',
      modification_success: {
        IN_VENUE: 'Reserva modificada correctamente',
        ROOM_SERVICE: 'Pedido modificado correctamente',
      },
      modification_pending: 'Esperando aprobación de modificación',
      modification_error: 'Error al solicitar la modificación',
      order_refund_disclaimer: 'El reembolso del pedido se realizará automáticamente en caso de cancelarse la reserva.',
    },
    complete: {
      IN_VENUE: 'Reserva completada',
      ROOM_SERVICE: 'Pedido completado',
    },
    pending: 'Pendiente de confirmación',
    visit_reservations_prompt: 'Puedes encontrar tu {entityType} en <span class="font-weight-bold">{dashboardName}</span>',
    confirmation_prompt_reservation: 'Esta reserva será confirmada y recibirás un e-mail cuando sea aceptada.',
    confirmation_prompt_order: 'Este pedido será confirmado y recibirás un e-mail cuando sea aceptado.',
    no_children_allowed: 'No se permiten niños',
    over_capacity: 'El número de asistentes para el intervalo seleccionado excede la capacidad máxima',
    reached_capacity: 'Capacidad máx.',
    deliver_to_room: 'A entregar en habitación',
    account_text: 'Selecciona una cuenta de pago. Los precios y las cantidades de los productos se mostrarán en función del saldo de la cuenta seleccionada.',
    details: 'Detalles',
    reservation_price: 'Precio de la reserva',
    total: 'Total',
    subtotal: 'Subtotal',
    attendee_type: 'Cantidad de {type}',
    max_attendee_type: 'El número máximo de asistentes es de {maxAttendeesPerReservation}',
    delivery_terms: 'Términos de entrega',
    booking_terms: 'Términos de reserva',
    another_reservation_restriction: 'Ya tienes una reserva para {activityName} a las {activityTime}. Para continuar, comuníquese con un miembro del personal o elija otra hora.',
    service_charge: 'Cargo por servicio {serviceCharge}%',
    payment_method: 'Método de pago',
    room_charge: 'Cargo a la habitación',
    amount_to_be_paid: 'Total a pagar',
    no_upcoming_reservations: 'No hay reservas próximas',
    created_by_modification_notice: {
      ROOM_SERVICE: 'Este es un pedido nuevo creado por un operario, y reemplaza un pedido hecho por ti que ha sido cancelado',
      IN_VENUE: 'Esta es una reserva nueva creada por un operario, y reemplaza una reserva hecha por ti que ha sido cancelada',
    },
  },
  upcoming_events: {
    no_events: 'No hay eventos',
    no_events_today: 'No hay eventos hoy',
    see_future_events: 'Ver otros días',
    requires_reservation: 'Requiere reserva',
    today: 'Hoy',
    select_prompt: 'Selecciona las categorías que te interesen',
    more: 'más',
    select_categories: 'Filtra por categoría',
    actions: {
      select_all: 'Seleccionar todas',
      deselect_all: 'Deseleccionar todas',
    },
  },
  activities: {
    by_category: 'Buscar por categoría',
    details: {
      see_timetable: 'Ver horario',
      closed: {
        IN_VENUE: 'Cerrado ahora',
        ROOM_SERVICE: 'Aceptando pedidos',
      },
      open: 'Abierto',
      timetable: 'Horario',
      related_activities: 'Puede que te guste...',
    },
    dow: {
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábabo',
      sunday: 'Domingo',
    },
    reservation_types: {
      IN_VENUE: 'Reserva',
      ROOM_SERVICE: 'Servicio de habitación',
      EXTERNAL_RESERVATION_SYSTEM: 'Sistema de reserva externo',
    },
  },
  sign_out: {
    warning: '¿Seguro que quieres cerrar sesión?',
    no_password: 'Si cierras sesión sin haber elegido una contraseña, tendrás que iniciar sesión utilizando el enlace en tu correo electrónico.',
  },
  reservations: {
    upcoming: 'Próximas',
    past: 'Pasadas',
    all: 'Todas',
    log_status: {
      PAYMENT_ATTEMPT: 'Error de pago',
      PAID: 'Pagado',
      SUCCESS: 'Pagado',
      REFUNDED: 'Reembolso',
      REFUSED: 'Error de pago',
    },
    status: {
      PENDING: 'Esperando aprobación',
      ACCEPTED: 'Aceptada',
      REJECTED: 'Rechazada',
      ATTENDED: 'Completada',
      ABSENT: 'Ausente',
      CANCELLED: 'Cancelada',
      PENDING_MODIFICATION: 'Cambio solicitado',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Cambiada por personal',
      CANCELLED_BY_ACTIVITY_MODIFICATION : 'Cancelada y modificada',
      PENDING_PAYMENT: 'Pago pendiente',
    },
    short_status: {
      PENDING: 'Pendiente',
      PENDING_MODIFICATION: 'Pendiente',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Aceptada',
      CANCELLED_BY_ACTIVITY_MODIFICATION: 'Cancelada',
      UPCOMING: 'Próximo',
    },
    order_status: {
      ACCEPTED: 'Aceptado',
      REJECTED: 'Rechazado',
      ATTENDED: 'Entregado',
      ABSENT: 'Ausente',
      CANCELLED: 'Cancelado',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Cambiado por personal',
      CANCELLED_BY_ACTIVITY_MODIFICATION : 'Cancelado por cambio',
    },
    order_short_status: {
      ACCEPTED: 'Aceptado',
      REJECTED: 'Rechazado',
      ATTENDED: 'Entregado',
      ABSENT: 'Ausente',
      CANCELLED: 'Cancelado',
      ACCEPTED_BY_ACTIVITY_MODIFICATION: 'Aceptado',
      CANCELLED_BY_ACTIVITY_MODIFICATION: 'Cancelado',
    },
    timeline_status: {
      confirmed: {
        IN_VENUE: 'Confirmada',
        ROOM_SERVICE: 'Confirmado',
      },
      updated: {
        IN_VENUE: 'Actualizada',
        ROOM_SERVICE: 'Actualizado',
      },
      accepted_by_activity_modification: {
        IN_VENUE: 'Confirmada',
        ROOM_SERVICE: 'Confirmado',
      },
      cancelled_by_activity_modification: {
        IN_VENUE: 'Cancelada y cambiada',
        ROOM_SERVICE: 'Cancelado y cambiado',
      },
      pending_approval: 'Pendiente de aprobación',
      requested_modification: 'Cambio solicitado',
      payment: 'Pago',
    },
    details_tabs: {
      TIMELINE: 'Progreso',
      DETAILS: 'Detalles',
    },
    hide_timeline: 'Ocultar resumen de estado',
    finished: {
      IN_VENUE: 'Tu reserva ha finalizado',
      ROOM_SERVICE: 'Tu pedido ha finalizado',
    },
    refund_emitted: 'Reembolso emitido',
    no_account: 'Sin cuenta de pago',
    guest_type_not_selectable: 'Tipo de huésped no permitido',
    inactive_account: 'Cuenta inactiva',
    no_more_reservations: 'No hay más reservas',
    no_reservations: 'No hay reservas',
    inactive_guest: 'Huésped inactivo',
    show_more: 'Ver más',
    details: 'Detalles',
    reservation_date: 'Fecha y hora de la reserva ',
    room: 'Entregar en ',
    go_to_previous: {
      IN_VENUE: 'Ir a la reserva anterior',
      ROOM_SERVICE: 'Ir al pedido anterior',
    },
    estimated_at: {
      IN_VENUE: 'Reservado para ',
      ROOM_SERVICE: 'Estimado para ',
    },
    requested_for: {
      IN_VENUE: 'Reservado para ',
      ROOM_SERVICE: 'Solicitado para ',
    },
    adults: 'Adultos ',
    children: 'Niños ',
    title: 'Tu {entityType}',
    comments: {
      ROOM_SERVICE: 'Añade un comentario o instrucciones.',
      IN_VENUE: 'Instrucciones especiales...',
    },
    ticket: 'Ticket',
    see_details: 'Ver detalles',
    refund_ticket: 'Ticket de reembolso',
    categories: 'Categorías',
    products: 'Productos',
    card_used: 'Tarjeta usada',
  },
  catalog: {
    view_order: 'Ver resumen',
    cancel: 'Cancelar',
    update_product: 'Actualizar producto',
    how_many: '¿Cantidad...?',
    you_may_also_like: 'Podría gustarte…',
    do_payment: 'Pagar',
    confirm_order: 'Confirmar pedido',
    out_of_stock: 'Sin existencias',
    remove: 'Eliminar',
    empty_cart: 'No hay productos seleccionados',
    tax: 'Impuesto',
    product_quantity: '{qty} productos | {qty} producto | {qty} productos',
    product_quantity_short: '{qty} prods. | {qty} prod. | {qty} prods.',
    min_selected: '{min} mín.',
    max_selected: '{max} máx.',
    actions: {
      add: 'Añadir',
      remove: 'Eliminar',
      update: 'Actualizar',
      see_details: 'Ver detalles',
    },
  },
  pages: {
    content: {
      dresscode: 'Normas de etiqueta',
      people_also_liked: 'También podría gustarte',
      weekly_schedule: 'Programación semanal',
    },
    opening_hours: {
      closed: 'Cerrado',
      schedule: {
        now: 'Abierto ahora',
        open: 'Abre el {day} a las {startHour}',
        close: 'Cierra a las {endHour}',
      },
    },
    reservation_type: {
      in_venue_required: 'Reserva requerida',
      in_venue: 'Reserva',
      room_service: 'Servicio de habitación',
    },
    reservation_list_types: {
      in_venue: 'Reservas',
      room_service: 'Pedidos',
      all: 'Todos',
    },
  },
  no_reservations: {
    base: 'No hay {type} {status}',
    type: {
      ALL: 'eventos',
      ROOM_SERVICE: 'pedidos',
      IN_VENUE: 'reservas',
    },
    status: {
      all: {
        ROOM_SERVICE: '',
        IN_VENUE: '',
      },
      upcoming: {
        ROOM_SERVICE: 'próximos',
        IN_VENUE: 'próximas',
      },
      past: {
        ROOM_SERVICE: 'pasados',
        IN_VENUE: 'pasados',
      },
    },
  },
}
